import moment from "moment";

export const calculateTime = (time) => {
    let value = '';
    let unitOfMeasure;
    if (moment().diff(time, 'seconds') < 60) {
        value = moment().diff(time, 'seconds');
        unitOfMeasure = moment().diff(time, 'seconds') === 1 ? 'second' : 'seconds';
    } else if (moment().diff(time, 'minutes') < 60) {
        value = moment().diff(time, 'minutes');
        unitOfMeasure = moment().diff(time, 'minutes') === 1 ? 'minute' : 'minutes';
    } else if (moment().diff(time, 'hours') < 24) {
        value = moment().diff(time, 'hours');
        unitOfMeasure = moment().diff(time, 'hours') === 1 ? 'hour' : 'hours';
    } else {
        value = moment().diff(time, 'days');
        unitOfMeasure = moment().diff(time, 'days') === 1 ? 'day' : 'days';
    }
    return `${value} ${unitOfMeasure} ago`
}